/**
 * How to import SVG Icons?
 *
 * 1. Export and download icons from figma design file.
 * 2. Unzip and move .svg files to ~/./assets/svg.
 * 3. run "npm run generateSvgIconIndex" to auto generate index.tsx, which contains all converted svg files.
 * 4. import Icon
 * 5. use Icon in your component.
 *
 * Simple Usage
 * <Icon name="icon-name" />
 *
 */

import { useDripsyTheme } from 'dripsy';
import React from 'react';
import * as SVGIcons from './index';

export type SVGIconList = keyof typeof SVGIcons;

// Convert type SVGIconList to array of string
export const SVGIconListArray = Object.keys(SVGIcons) as SVGIconList[];

export interface IconProps {
  name: SVGIconList;
  height?: number;
  width?: number;
  color?: string;
  themeColor?: string;
  defaultSVGColor?: boolean;
}

const defaultDimensions = {
  height: 20,
  width: 20
};

export const Icon: React.FC<IconProps> = (props) => {
  const { theme } = useDripsyTheme();
  const {
    name = 'placeholderLight20',
    height = defaultDimensions.height,
    width = defaultDimensions.width,
    color,
    themeColor,
    defaultSVGColor
  } = props;

  let iconColor = defaultSVGColor ? undefined : color;
  let iconColorIos = defaultSVGColor ? undefined : color || theme.colors?.$iconDefault;
  if (!defaultSVGColor && themeColor && theme.colors?.[themeColor]) {
    iconColor = theme.colors?.[themeColor] as string;
    iconColorIos = iconColor;
  }

  const SVGIcon = SVGIcons[name]?.default || SVGIcons.placeholderLight20.default;
  return <SVGIcon height={height} width={width} color={iconColorIos} padding={0} />;
};
